import { H_CAPTCHA_NAME } from "@/constants/auth/captcha";

export default {
  methods: {
    resetCaptcha (type, id, handleHcaptchaReset) {
      switch (type) {
        case H_CAPTCHA_NAME:
          handleHcaptchaReset()
            break
          default:
            window.mtcaptcha.resetUI()
            window.mtcaptchaConfig.renderQueue.push(id)
          }
        }
    }
}
